export class ConfirmationModel {
  public title: string;
  public content: string;
  public btnSubmit: string;
  public btnSubmitRed: string;
  public btnCancel: string;
}
